import React, { PureComponent } from 'react'
import { observer, inject } from 'mobx-react'
import Message from '../../components/message/Notice'

const style = {
  height: '100%',
  width: '100%'
}
/*
主页面渲染
*/
@observer
@inject('messageStore')
class Frame extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {

    }
  }

  render () {
    return (
      <section style={style} >
        {this.props.children}
        {/*  提示消息 */}
        <Message
          data={this.props.messageStore.message} />
      </section>
    )
  }
}

export default Frame



// WEBPACK FOOTER //
// ./src/containers/index/Layout.jsx